export default __webpack_public_path__ + "static/media/06-cortes-chocolate.b4a987de.png";